import React from 'react'
import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { Thanks } from 'experiences/contact/thanks'

const ThanksPage: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<Thanks />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default ThanksPage
